import React, { Component } from 'react';
import Carousel from "@ingka/carousel";

import Loading, { LoadingBall } from "@ingka/loading";

import FirstSection from './FirstSection';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';
import FourthSection from './FourthSection';
import FifthSection from './FifthSection';
import SixthSection from './SixthSection';
import SeventhSection from './SeventhSection';

import ModalUI from '../UI/ModalUI';

class Categories extends Component {

    constructor(props) {
        super();
        this.state = {
            loading: false,
            categories: [],
            restaurant:null,
            selectedCategory: null,
            modalIsOpen: false,
            modalProp: props
        };
    }

    onCategorySelected = (category) => {

        console.log("onCategorySelected :::",category);
        
        this.setState({
            selectedCategory: category
        });
    }

    async componentDidMount() {
        this.setState({
            loading: true
        });
        // console.log("resturant :::",restaurant)

        const response = await fetch(`https://www.ikea.com/ae/en/local-apps/restaurant-menu/resturant-data.json`);
        const resp = await response.json();
        console.log("resp is :::",resp);
        this.setState({ 
            categories: resp.categories,
            restaurant:resp,
            loading: false,
            selectedCategory: resp.categories.length ? resp.categories[0] : null
        });
        
    }

    categoryHasId = (value) =>{
        return  value.toLowerCase().replace(/\s+/g, "-");
    }

    ucFirst = (value) => {
        if(!value || !value.length) return '';
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    clickButton = () =>{
        console.log("clickButton");
        this.setState({ 
            modalIsOpen: true,
        });
    }

     closeBtnUpdate = () => {
        console.log("closeBtnUpdate ::::");
        this.setState({ 
            modalIsOpen: false,
            modalProp:null
        });
    }

    displayPopupOnClick = (props) =>{
        console.log("clickImage in Categories:::",props);
        this.setState({ 
            modalIsOpen: true,
            modalProp:props
        });
    }

    render() {
        const { categories, loading, selectedCategory,restaurant,modalIsOpen,modalProp } = this.state;
        
        return (
            <>
            {loading && <Loading className="loading--custom-class spinnig loading__sr-only-text" text="Loading..." labelTransitions>
                <LoadingBall />
            </Loading>}
            
            {/* <button onClick={this.clickButton}></button> */}

            {modalIsOpen && <ModalUI closebtn={this.closeBtnUpdate} item={modalProp}></ModalUI>}

                <Carousel>
                {!loading && categories.length > 0 && (
                    categories.map((category, number) =>
                        <a
                            href={`#` + this.categoryHasId(category.name)}
                            onClick={() => this.onCategorySelected(category)}
                            className={`pill pill--small mr-2 ${selectedCategory && selectedCategory.id === category.id ? 'pill--active' : ''}`}
                            key={`pill-${number}`}>
                            <span className="pill__label">{this.ucFirst(category.name)}</span>
                        </a>
                    )
                )}
                </Carousel>
                {selectedCategory && selectedCategory.description && selectedCategory.description !== '' && (
                    <p>  {selectedCategory.description} </p>
                )}

                {!loading && categories.length > 0 && <FirstSection item={restaurant} onClick = {()=>this.displayPopupOnClick(modalProp)}/>}
                {!loading && categories.length > 0 && <SecondSection item={restaurant} onClick = {this.displayPopupOnClick}/>}
                {!loading && categories.length > 0 && <ThirdSection item={restaurant} onClick = {this.displayPopupOnClick}/>}
                {!loading && categories.length > 0 && <FourthSection item={restaurant} onClick = {this.displayPopupOnClick}/>}
                {!loading && categories.length > 0 && <FifthSection item={restaurant} onClick = {this.displayPopupOnClick}/>}
                {!loading && categories.length > 0 && <SixthSection item={restaurant} onClick = {this.displayPopupOnClick}/>}
                {!loading && categories.length > 0 && <SeventhSection item={restaurant} onClick = {this.displayPopupOnClick}/>}


            </>
        );
    }
}

export default Categories;
